import eventBusGtm from '~/composables/eventBusGtm';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  window.addEventListener('message', (event) => {
    if (
      event.origin === window.origin &&
      event.data?.type === 'datalayer-push' &&
      event.data?.event
    ) {
      eventBusGtm.emit('trackEvent', event.data.event);
    }
  });
});
